import DateFormatter from "@/helpers/formatters/date.formatter.js";

class BaliseFormatter {

    baliseFormat(data) {
        if (!data) return null;

        return {
            id: data.id ?? null,
            imei: data.baliseId ?? null,
            name: data.name ?? null,
            immat: data.registrationPlate ?? null,
            icon: data.icon ?? null,
            vehicle: data.vehicle ?? null,
            color: data.color ?? null,
            make: data.make ?? null,
            model: data.model ?? null,
            vin: data.vin ?? null,
            comment: data.comment ?? null,
            type: data.type ?? null,
            simNumber: data.simNumber ?? null,
            lastSeen: data.lastPositionDate ?? null,
            displayLastSeen: DateFormatter.formatDate(data.lastPositionDate),
            lastLatitude: data.lastLatitude ?? null,
            lastLongitude: data.lastLongitude ?? null,
            lastBattery: data.lastBattery ?? null,
            lastPowerVoltage: data.lastPowerVoltage ?? null,
            powerConnected: data.powerConnected ?? null,
            lastAddress: data.lastAddress ?? null,
            lastSpeed: data.lastSpeed ?? null,
            lastLevelGPS: data.lastLevelGPS ?? null,
            lastLevelGSM: data.lastLevelGSM ?? null,
            lastTemperature: data.lastTemperature ?? null,
            updatedAt: data.lastPositionDate ?? null,
            createdAt: DateFormatter.formatDate(data.serviceDate),
            immatriculation: data.vehicleImmatriculation ?? null,
            remoteMonitoring: data.remoteMonitoring ?? null,
            free: data.free ?? null,
            allowedSMS: data.commercialPackage ? data.commercialPackage.allowedSMS : false,
            commercialPackageId: data.commercialPackageId ?? null,
            groupName: data.group?.name ?? "Sans groupe",
            groupId: data.group?.id ?? null,
            commercialPackage: data.commercialPackage ?? null,
            blocageDemarreur: data.blocageDemarreur ?? null,
            blocageDemarreurEnabled: data.blocageDemarreurEnabled ?? null,
            ongoingAlarm: data.ongoingAlarm ?? null,
            corridoringId: data.corridoringId ?? null,
            corridoringOut: data.corridoringOut ?? null,
            featureCorridoring: data.featureCorridoring ?? null,
            featureCallback: data.featureCallback ?? false,
            digitalIOs: data.digitalIOs ?? null,
            parkingLat: data.parkingLat ?? null,
            parkingLong: data.parkingLong ?? null,
            atlantId: data.atlantId ?? null,
            client: data.client ?? null,
            status: data.status ?? null,
            plusAContact: data.plusAContact ?? null,
            geofencingId: data.geofencingId ?? null,
            geofencingOut: data.geofencingOut ?? null,

            ignition: data.ignition ?? null,
            movement: data.movement ?? null,
            drive: data.drive ?? null,

            hasTag: data.hasTag ?? null,
            badgeReading: data.badgeReading ?? null,

            lastTagPresentAt: data.lastTagPresentAt ?? null,
            lastTagAbsentAt: data.lastTagAbsentAt ?? null,

            displayLastTagPresentAt: DateFormatter.formatDate(data.lastTagPresentAt),
            displayLastTagAbsentAt: DateFormatter.formatDate(data.lastTagAbsentAt),
            securityMode: data.securityMode ?? 'NOT_SUPPORTED',
            carjackingMode: data.carjackingMode ?? 'NOT_SUPPORTED',
        };
    }

    balisesFormat(data) {
        if (!Array.isArray(data)) return [];

        return data
            .map(balise => this.baliseFormat(balise))
            .filter(Boolean);
    }
}

export default new BaliseFormatter();